/**
 * When a suggestion list is wired to the field it suggests for (FR-2.11,
 * FR-4.13).
 *
 * A `datalist` opens on focus, before a character is typed, showing everything
 * it holds. On a phone that dropdown is drawn over the keyboard -- so a brand
 * list long enough to fill the screen leaves the field focused with no way to
 * type into it, which is the one thing the list exists to help with.
 *
 * So the field carries no `list` until something has been typed. What opens
 * then is filtered to the prefix, which is short enough to sit above the
 * keyboard rather than over it. The requirement asks for values suggested "as
 * the user types", which is this, rather than before.
 *
 * It is the attribute that is withheld, not the `datalist` that is emptied: an
 * input whose `list` points at a list with nothing in it still opens a dropdown
 * onto nothing. Withholding it leaves a plain text box, which is what a field
 * with nothing to suggest should be.
 */
export function suggestionList(
  listId: string,
  typed: string,
  offered: readonly unknown[],
): { list?: string } {
  // Whitespace is not a prefix worth filtering on, and a lone space matches
  // every brand with two words in it -- which is the long dropdown again.
  if (typed.trim() === '') return {};
  // Nothing to offer yet is a dropdown onto nothing, which is worse than none.
  if (offered.length === 0) return {};
  return { list: listId };
}
